// extracted by mini-css-extract-plugin
module.exports = {"nav-workstation":"nav-workstation--2gY81","scroll":"scroll--Y9GYc"};